export default __webpack_public_path__ + "static/media/microphone.48f05203.png";